<template>
  <div class="botTableWrap ip">
    <div class="bot_label" v-if="!isExcel"><span><v-icon>today</v-icon>일자별 리포트</span>
      <div>
        <select class="select_content" v-model="selected_nm">
          <option value="total">전체 보기</option>
          <template v-for="(contract, n) in campaignData">
            <option :value="contract.ad_knd_nm" :key="n">{{contract.ad_knd_nm}}</option>
          </template>
        </select>
      </div>
    </div>
    <div class="inter_bot_wrap">
      <table class="inter_bot flipTable">
        <tr v-if="isExcel"><td>{{adNm}}</td></tr>
        <tr>
          <template v-for="header in tableHeader">
            <th :key="header" v-if="checkMIP(header)">
              {{header}}
            </th>
          </template>
        </tr>
        <tbody>
          <template v-for="(daysData, index) in viewDaysData">
            <tr :class="[index === 0 ? 'f_inter_tr' : '_inter_tr', daysData.ad_knd_nm === null ? '_isEmpty' : '']" :key="index">
              <td v-for="(data, i) in dataKey"
                @click="showSubList(daysData, i)"
                class="dataTd_inter" :class="[i === 0 ? 'nm_Td' : '']"
                v-if="checkMIP(data)" :key="index + data">
                <v-icon class="icon" v-if="i === 0 && showIcon(daysData)">
                  {{checkDate(daysData.ymd) ? up : down}}
                </v-icon>
                <div class="bot_dataWrap inter">
                  <!-- // 여기이다. -->
                  {{parseData(daysData[data], data)}}
                </div>
              </td>
            </tr>
            <template v-if="checkSubList(daysData)">
              <tr v-for="(ad, n) in daysData.data" :key="index + '_' + n" class="ip_subList">
                <td v-for="(data, i) in dataKey" class="dataTd_inter" :class="i === 0 ? 'sub_nm_Td' : ''" v-if="checkMIP(data)" :key="index + data">
                  <div class="inter" :class="i !== 0 ? 'bot_dataWrap' : ''">
                    {{ data === 'ymd' ? ad.ad_knd_nm : parseData(ad[data], data) }}
                  </div>
                </td>
              </tr>
            </template>
          </template>
           <tr>
            <th class="_total">합계</th>
            <th><div class="bot_dataWrap">{{ parseData(totalData.imp, '') }}</div></th>
            <th v-if="this.campaignType !== 'CPCV'"><div class="bot_dataWrap">{{ parseData(isCampaignType(campaignType) ? totalData.view : totalData.click, '') }}</div></th>
            <th  v-if="this.campaignType === 'CPCV'"><div class="bot_dataWrap">{{ parseData(isCampaignType(campaignType) ? totalData.click : totalData.view, '') }}</div></th>
            <th><div class="bot_dataWrap">{{parseData(totalData.ctr, 'ctr')}}</div></th>
            <th  v-if="this.campaignType !== 'CPCV'"><div class="bot_dataWrap">{{ parseData(isCampaignType(campaignType) ? totalData.click : totalData.view, '') }}</div></th>
            <th v-if="this.campaignType !== 'CPCV'"><div class="bot_dataWrap">{{isCampaignType(campaignType) ? '100.0' : parseData(totalData.vtr, '') }}</div></th>
            <th><div class="bot_dataWrap">{{this.campaignType === 'CPCV' ? parseData(totalData.cpcv,'') : ''}}</div></th>
            <th><div></div></th>
            <th><div></div></th>
            <th><div></div></th>
            <th><div></div></th>
            <th><div></div></th>
            <th v-if="isCampaignType(campaignType)"><div></div></th>
            <th><div class="bot_dataWrap">{{ parseData(totalData.budget_amt, '') }}</div></th>
          </tr>
        </tbody>

        <tr v-if="isExcel"><td></td></tr>
      </table>
    </div>
  </div>
</template>

<script>
  import { parseData } from '@/assets/func'
  import _ from 'lodash'

  export default {
    name: 'InterAdBot',
    props: {
      campaignData: Array,
      campaignType: String,
      isExcel: Boolean,
      getViewDataList: Function,
      checkDate: Function,
      clickDate: Function,
      adNm: String,
      num: Number
    },
    data () {
      return {
        selected_nm: 'total',
        down: 'keyboard_arrow_down',
        up: 'keyboard_arrow_up',
        isIp: [
          'ymd',
          'imp_cnt',
          'click_cnt',
          'ctr',
          'view_cnt',
          'vtr',
          'uv_cnt',
          'play_cnt', // 모바일 인터플레이만
          'play_sec_avg',
          'end_rate',
          'play_Q1_rate',
          'play_Q2_rate',
          'play_Q3_rate',
          'budget_amt'
        ],
        isCv: [
          'ymd',
          'imp_cnt',
          'click_cnt',
          'ctr',
          'view_cnt',
          'vtr',
          'cpvc',
          'uv_cnt',
          'play_sec_avg',
          'end_rate',
          'play_Q1_rate',
          'play_Q2_rate',
          'play_Q3_rate',
          'budget_amt'
        ],
        isCpcv: [
          'ymd',
          'imp_cnt',
          'click_cnt',
          'ctr',
          'cpcv',
          'uv_cnt',
          'play_sec_avg',
          'end_rate',
          'play_Q1_rate',
          'play_Q2_rate',
          'play_Q3_rate',
          'budget_amt'
        ],
        ipHeader: [
          '날짜',
          '노출수',
          '클릭수',
          'CTR(%)',
          'VIEW',
          'VTR(%)',
          'UV',
          '재생수',
          '평균재생(초)',
          '재생완료(%)',
          '재생Q1(%)',
          '재생Q2(%)',
          '재생Q3(%)',
          '일 광고비'
        ],
        cvHeader: [
          '날짜',
          '노출수',
          '클릭수',
          'CTR(%)',
          'VIEW',
          'VTR(%)',
          'VIEW + CLICK',
          'UV',
          '평균재생(초)',
          '재생완료(%)',
          '재생Q1(%)',
          '재생Q2(%)',
          '재생Q3(%)',
          '일 광고비'
        ],
        cpcvHeader: [
          '날짜',
          '노출수',
          '클릭수',
          'CTR(%)',
          '시청완료',
          'UV',
          '평균재생(초)',
          '재생완료(%)',
          '재생Q1(%)',
          '재생Q2(%)',
          '재생Q3(%)',
          '일 광고비'
        ]
      }
    },
    methods: {
      checkMIP (key) {
        if (key !== 'play_cnt' && key !== '재생수') return true
        if (this.campaignType === 'HIP') return true
        else return false
      },
      parseData (data, key) {
        return parseData(data, key)
      },
      checkSubList (data) {
        if (!this.checkDate) return false
        if (this.checkDate(data.ymd)) return true
        return false
      },
      showIcon (data) {
        if (data.data === undefined || this.isExcel) return false
        if (data.data.length > 0 && data.data[0].ad_knd !== null) return true
        return false
      },
      showSubList (data, i) {
        if (i !== 0) return
        if (this.showIcon(data)) this.clickDate(data.ymd)
      },
      getTotalData () {
        let data = this.viewDaysData
        let imp = _.sumBy(data, function (o) { return o.imp_cnt * 1 })
        let budgetAmt = _.sumBy(data, function (o) { return o.budget_amt * 1 })
        let click = _.sumBy(data, function (o) { return o.click_cnt * 1 })
        let view = _.sumBy(data, function (o) { return o.view_cnt * 1 })
        let playCnt = _.sumBy(data, function (o) { return o.play_cnt * 1 })
        let ctr = click / imp * 100
        ctr = isNaN(ctr) ? 0 : ctr
        let vtr = view / (playCnt || imp) * 100
        vtr = isNaN(vtr) ? 0 : vtr
        const cpcv = this.campaignType === 'CPCV' ? _.sumBy(data, function (o) { return (o.cpcv === undefined ? 0 : o.cpcv) * 1 }) : 0
        const cpv = this.campaignType === 'CPV' ? _.sumBy(data, function (o) { return (o.cpvc === undefined ? 0 : o.cpvc) * 1 }) : 0
        let res = {imp: imp, click: click, ctr: ctr, view: view, vtr: vtr, budget_amt: budgetAmt, cpcv: cpcv, cpv: cpv}
        if (!this.campaignType === 'CPCV' && this.campaignType.indexOf('CV') > -1) res.view_cnt = _.sumBy(data, function (o) { return (o.cpvc === undefined ? 0 : o.cpvc) * 1 })
        return res
      },
      isCampaignType () {
        this.campaignType
        switch (this.campaignType) {
          case 'CPCV' :
            return true
          case 'CPV' :
            return false
          default :
            if (this.campaignType.indexOf('CV') > -1) return true // 'IP', 'AIP', 'OHIP', 'JIP', 'HIP'
            else return false
        }
      }
    },
    computed: {
      tableHeader () {
        let res = []
        if (this.isExcel && this.adNm === 'total') {
          return ['날짜', '노출수', '클릭수', 'CTR(%)', 'VTR(%)', 'VIEW', '일광고비']
        }

        switch (this.campaignType) {
          case 'CPCV' :
            res = [...this.cpcvHeader]
            break
          case 'CPV' :
            res = [...this.ipHeader]
            break
          default :
            if (this.campaignType.indexOf('CV') > -1) res = [...this.cvHeader] // 'IP', 'AIP', 'OHIP', 'JIP', 'HIP'
            else res = [...this.ipHeader]
            break
        }

        // if (this.campaignType === 'CVPIP' || this.campaignType === 'PIP') res[res.indexOf('UV')] = 'SKIP'
        if (this.campaignType.indexOf('PIP') > -1) res[res.indexOf('UV')] = 'SKIP'
        return res
      },
      dataKey () {
        let res = []
        switch (this.campaignType) {
          case 'CPCV' :
            res = [...this.isCpcv]
            break
          case 'CPV' :
            res = [...this.isIp]
            break
          default :
            if (this.campaignType.indexOf('CV') > -1) res = [...this.isCv] // 'IP', 'AIP', 'OHIP', 'JIP', 'HIP'
            else res = [...this.isIp]
            break
        }

        // if (this.campaignType === 'CVPIP' || this.campaignType === 'PIP') res[res.indexOf('uv_cnt')] = 'skip_cnt'
        if (this.campaignType.indexOf('PIP') > -1) res[res.indexOf('uv_cnt')] = 'skip_cnt'
        return res
      },
      totalData () {
        return this.getTotalData()
      },
      viewDaysData () {
        if (!this.getViewDataList) return
        if (this.isExcel) {
          return this.getViewDataList(this.adNm)
        }
        return this.getViewDataList(this.selected_nm)
      }
    },
    mounted () {
      if (this.isExcel) {
        if (this.adNm === 'total') this.$el.getElementsByTagName('table')[0].setAttribute('id', 'inter_table_base')
        else this.$el.getElementsByTagName('table')[0].setAttribute('id', `inter_table_ad${this.num}`)
      }
    }
  }
</script>

<style scoped>
  .bot_label {
    position: absolute;
    top: -29px;
    left: 5px;
    height: 25px;
    font-weight: 500;
    color: #689f38;
    line-height: 25px;

    display: flex;
    justify-content: space-between;
    width: calc(100% - 5px);
  }
  .bot_label i {
    margin-right: 3px;
    font-weight: normal;
  }
  .icon {
    vertical-align: middle;
    color: #689f38;
    font-weight: bold;
  }
  .inter_bot_wrap {
    background: #fff;
    border: 1px solid #d1dce3;
    border-radius: 7px;
    padding: 5px 10px;
  }
  .inter_bot {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  .dataTd_inter {
    text-align: center;
  }
  .dataTd_inter.nm_Td {
    text-align: left;
    padding-left: 30px;
    min-width: 70px;
    max-width: 180px !important;
  }
  .dataTd_inter .icon {
    position: absolute;
    left: 10px;
  }
  .dataTd_inter.sub_nm_Td .inter {
    text-align: left;
  }
  .ip_subList {
    background: #f2f3f5;
  }

  .select_content {
    vertical-align: middle;
    border-radius: 6px;
    height: 23px;
    padding-bottom: 3px;
  }
  .select_content:hover {
    cursor: pointer;
  }

  ._isEmpty {
    background: #f7f9fa;
  }
  th, td {
    height: 25px;
  }
  th {
    border-bottom: 2px solid #eaeaea;
  }
  td {
    border-bottom: 1px solid #eaeaea;
  }
  tr:last-child td {
    border-bottom: none;
  }
  @media screen and (max-width: 800px) {
    .inter_bot_wrap {
      width: calc(100% - 22px);
    }
    .bot_dataWrap.inter {
      width: 100%
    }
    .f_inter_tr .dataTd_inter {
      padding-right: 0 !important;
      padding-left: 10px;
    }
    ._inter_tr .dataTd_inter {
      padding-right: 0 !important;
      padding-left: 7px;
    }
  }
  @media screen and (max-width: 600px) {
    th, td {
      border-bottom: none;
      height: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// InterPlayAdBottom.vue?18b57644